export default __webpack_public_path__ + "static/media/colla.b6b412f1.png";